import { render } from "./ThirdTierAgent.vue?vue&type=template&id=19698919&scoped=true"
import script from "./ThirdTierAgent.vue?vue&type=script&lang=js"
export * from "./ThirdTierAgent.vue?vue&type=script&lang=js"

import "./ThirdTierAgent.vue?vue&type=style&index=0&id=19698919&lang=scss&scoped=true"

import exportComponent from "E:\\zhouwang\\work\\web_dev\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-19698919"]])

export default __exports__